import React from 'react'
import CTA from 'components/CTA'

export const Cta = ({ slug }: { slug: string }) => (
  <CTA
    fullWidth
    trackProps={{
      category: slug,
      content_type: 'product',
      location: 'hero',
    }}
  />
)
